import { ADD_TO_BE_CREATED, CHANGE_NAME_TO_BE_CREATED, CHANGE_ORDER_TO_BE_CREATED, DELETE_TO_BE_CREATED } from './type'

export const addToBeCreated = () => {
  return {
    type: ADD_TO_BE_CREATED,
  }
}

export const deleteToBeCreated = (target_remove_index: number) => {
  return {
    type: DELETE_TO_BE_CREATED,
    target_remove_index
  }
}

export const changeNameToBeCreated = (changed_name: string, changed_target_id:number) => {
  return {
    type:CHANGE_NAME_TO_BE_CREATED,
    changed_name,
    changed_target_id
  }
}

export const changeOrderToBeCreated = (changed_order: number, changed_target_id:number) => {
  return {
    type:CHANGE_ORDER_TO_BE_CREATED,
    changed_order,
    changed_target_id
  }
}